import { h$1 as f, Y as a, v as w, u$1 as C, c as k, h as g, me as x, m as $, o as z } from "../chunks/register-Ba9sFUKZ.js";
import * as B from "react";
import { u } from "../chunks/class-map-B8OdeXIO.js";
import { e as v } from "../chunks/if-defined-_sZbHAlG.js";
import { o as c } from "../chunks/unsafe-svg-CXadf7rM.js";
import { v as L } from "../chunks/mixin-CP6jLr_x.js";
import { b as M } from "../chunks/motion-primitive-kIGz-vOk.js";
import { h as S, d as y } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { u as p } from "../chunks/showIfUsed-5lEKgJ0L.js";
const E = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M8 14L12 10L16 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, N = `<svg class="icon--close" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z" fill="#0063AD"/>
</svg>
`, Z = `<svg class="icon--error" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Error">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57752 11.0009C1.22025 11.6197 1.22025 12.3821 1.57752 13.0009L5.92282 20.5272C6.28009 21.146 6.94034 21.5272 7.65487 21.5272H16.3455C17.06 21.5272 17.7203 21.146 18.0775 20.5272L22.4228 13.0009C22.7801 12.3821 22.7801 11.6197 22.4228 11.0009L18.0775 3.47461C17.7203 2.85581 17.06 2.47461 16.3455 2.47461H7.65487C6.94034 2.47461 6.28008 2.85581 5.92282 3.47461L1.57752 11.0009ZM11.2502 7.75087C11.2502 7.33665 11.586 7.00087 12.0002 7.00087C12.4144 7.00087 12.7502 7.33665 12.7502 7.75087V12.2509C12.7502 12.6651 12.4144 13.0009 12.0002 13.0009C11.586 13.0009 11.2502 12.6651 11.2502 12.2509V7.75087ZM13.0002 16.0009C13.0002 16.5532 12.5525 17.0009 12.0002 17.0009C11.4479 17.0009 11.0002 16.5532 11.0002 16.0009C11.0002 15.4486 11.4479 15.0009 12.0002 15.0009C12.5525 15.0009 13.0002 15.4486 13.0002 16.0009Z" fill="#DD3636"/>
</svg>
`, A = `<svg class="icon--informational" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Informational">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.75C11.25 11.3358 11.5858 11 12 11C12.4142 11 12.75 11.3358 12.75 11.75V16.25ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8Z" fill="#0063AD"/>
</svg>
`, D = `<svg class="icon--success" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Succcess">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6081 9.43895C16.8506 9.10309 16.7748 8.6343 16.439 8.39187C16.1031 8.14944 15.6343 8.22519 15.3919 8.56105L10.8463 14.8586L8.52152 12.6092C8.22385 12.3211 7.74904 12.3289 7.46101 12.6266C7.17298 12.9243 7.1808 13.3991 7.47848 13.6871L10.4258 16.539C10.5823 16.6903 10.7967 16.7663 11.0135 16.7471C11.2303 16.7279 11.4281 16.6154 11.5555 16.439L16.6081 9.43895Z" fill="#248647"/>
</svg>
`, R = `<svg class="icon--warning" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Warning">
  <path d="M10.0652 3C10.835 1.66667 12.7595 1.66667 13.5293 3L21.3235 16.5C22.0933 17.8333 21.131 19.5 19.5914 19.5H4.00298C2.46338 19.5 1.50113 17.8333 2.27093 16.5L10.0652 3Z" fill="#FFC42D"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.25C11.25 12.6642 11.5858 13 12 13C12.4142 13 12.75 12.6642 12.75 12.25V7.75C12.75 7.33579 12.4142 7 12 7ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#061937"/>
</svg>
`, m = {
  beaconTagName: "beacon-notification",
  nestedComponents: ["beacon-icon-button"]
}, T = f`:host([motion-state=enabled][in-motion]) .motion-wrap,:host([collapsed]) .motion-wrap{overflow:hidden}`;
var I = (e, o, i, b) => {
  for (var n = o, r = e.length - 1, s; r >= 0; r--)
    (s = e[r]) && (n = s(n) || n);
  return n;
};
function V(e) {
  let o = class extends e {
    static get NotificationMotionStyles() {
      return [T];
    }
  };
  return o = I([
    S("NotificationMotion")
  ], o), o;
}
const j = f`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{background-color:var(--notification-background-color, var(--beacon-component-notification-color-background-standard))}:host([variant=informational]){--notification-background-color: var(--beacon-component-notification-color-background-informational);--notification-border-color: var(--beacon-component-notification-color-border-informational)}:host([variant=warning]){--notification-background-color: var(--beacon-component-notification-color-background-warning);--notification-border-color: var(--beacon-component-notification-color-border-warning)}:host([variant=error]){--notification-background-color: var(--beacon-component-notification-color-background-error);--notification-border-color: var(--beacon-component-notification-color-border-error)}:host([variant=success]){--notification-background-color: var(--beacon-component-notification-color-background-success);--notification-border-color: var(--beacon-component-notification-color-border-success)}:host(:is([type=inline],[type=toast])){max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.base{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);position:relative}.base .shell{display:grid;grid-column-gap:var(--beacon-reference-space-4);grid-template-columns:auto 1fr;grid-template-rows:auto;padding:var(--beacon-system-space-cell-contained)}.base .shell .icon{align-self:center;display:grid;grid-area:1}.base .shell .description{grid-area:2/2}.base .shell .action-zone{grid-area:3/2}.base .shell .chevron,.base .shell .close-wrapper{align-self:baseline;grid-area:1/3}.base .shell .title{align-self:center}.base .shell:has(.icon.hide-slot-area){grid-template-columns:1fr auto}.base .shell:has(.icon.hide-slot-area) .description{grid-area:2}.base .shell:has(.icon.hide-slot-area) .action-zone{grid-area:3}.base .shell:has(.icon.hide-slot-area) .chevron{grid-area:1/2}.base:not(.standard){color:var(--beacon-system-color-text-set-navy)}.base:not(.standard) ::part(icon-button){color:var(--beacon-reference-palette-functional-blue-3)}.base:is(.alert,.banner){padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-maxi)}.base:is(.alert,.banner) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.base:is(.alert,.banner) .description{margin-block-start:var(--beacon-reference-space-3)}.base:is(.alert,.banner) .action-zone{margin-block-start:var(--beacon-reference-space-5)}.base.inline{padding:var(--beacon-system-space-organism-normal)}.base.inline .shell,.base.inline .body{padding:var(--beacon-system-space-cell-contained)}.base.toast{box-shadow:var(--beacon-system-color-shadow-low);padding:var(--beacon-system-space-cell-contained)}.base.toast .shell{padding:var(--beacon-reference-space-2)}.base.toast .shell .icon{align-self:baseline}.base:is(.inline,.toast){border:var(--beacon-system-width-border-normal) solid var(--notification-border-color, var(--beacon-component-notification-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard)}.base:is(.inline,.toast) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.base:is(.inline,.toast) .description{margin-block-start:var(--beacon-reference-space-2)}.base:is(.inline,.toast) .action-zone{margin-block-start:var(--beacon-reference-space-3)}.base.banner:not(.expanded) .description,.base.banner:not(.expanded) .action-zone,.base.banner:not(.expanded) .body{margin:0;opacity:0}.base.banner .chevron{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0;transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.base.banner .chevron .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.base.banner .chevron[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.base.banner .chevron svg,.base.banner .chevron [beacon-tag-name=beacon-icon]{position:absolute}.base.banner .chevron:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.base.banner .chevron:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.base.banner .chevron:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.base.banner.expanded .chevron{transform:rotate(180deg)}.base.banner:not(.standard) svg{color:var(--beacon-reference-palette-functional-blue-3)}.base.banner :is(.description,.body,.action-zone){display:grid;transition-property:var(--unroll-from-transition-direction);--unroll-from-transition-property: grid-template-rows;grid-template-rows:0fr;transition-duration:var(--beacon-reference-motion-duration-5);transition-property:margin,opacity;transition-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}.base.banner :is(.description,.body,.action-zone) [class*=wrapper]{overflow:hidden}.base.banner.expanded :is(.description,.body,.action-zone){display:grid;grid-template-rows:1fr}.shell .icon{flex-shrink:0}.shell .icon svg,.shell .icon ::slotted(svg),.shell .icon ::slotted(img){max-block-size:var(--beacon-reference-space-7);max-inline-size:var(--beacon-reference-space-7)}.shell .content{flex-grow:1}.shell:has(.description.hide-slot-area):has(.action-zone.hide-slot-area){align-items:center}.description,.body{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 1920px){.base:is(.banner,.alert){padding-inline:0}}`;
var P = Object.defineProperty, H = Object.getOwnPropertyDescriptor, d = (e, o, i, b) => {
  for (var n = b > 1 ? void 0 : b ? H(o, i) : o, r = e.length - 1, s; r >= 0; r--)
    (s = e[r]) && (n = (b ? s(o, i, n) : s(n)) || n);
  return b && n && P(o, i, n), n;
}, l;
const t = (l = class extends L(x).with(
  M({ autoRemoveMotionClasses: !1 }),
  V
) {
  constructor() {
    super(...arguments), this.beaconTagName = m.beaconTagName, this.resetSpacing = !0, this.type = "inline", this.variant = "standard", this.dismissable = !1, this.collapsed = !1;
  }
  static get styles() {
    return [super.styles, j, this.NotificationMotionStyles];
  }
  static renderIcon(e) {
    if (e === "standard")
      return a`
        <div class="icon" aria-hidden="true">
          <slot ${p({ useParent: !0 })} name="icon"></slot>
        </div>
      `;
    let o = a``;
    switch (e) {
      case "informational":
        o = a`${c(A)}`;
        break;
      case "success":
        o = a`${c(D)}`;
        break;
      case "warning":
        o = a`${c(R)}`;
        break;
      case "error":
        o = a`${c(Z)}`;
        break;
    }
    return a`<div class="icon" aria-hidden="true">${o}</div>`;
  }
  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
  renderIconByType() {
    return this.type === "banner" ? a`
        <button
          class="${u({
      chevron: !0
    })}"
          aria-expanded="${String(!this.collapsed)}"
          aria-controls="description action-zone body"
          @click=${this.toggleCollapsed}>
          <span class="visually-hidden">Notification Details</span>
          ${c(E)}
        </button>
      ` : this.type === "toast" || this.dismissable ? w`
        <div class="close-wrapper">
          <${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.dismiss} class="close" variant="tertiary">${c(N)} Dismiss</${this.getScopedTag("beacon-icon-button")}>
        </div>
      ` : a``;
  }
  renderBodySlot() {
    return this.type !== "toast" ? a`
        <div
          class="body"
          id="body"
          ?inert=${v(this.inertContentStatus())}>
          <div class="motion-wrap">
            <slot name="body" ${p({ container: ".body" })}></slot>
          </div>
        </div>
      ` : a``;
  }
  dismiss() {
    C(this, k.DISMISS), this.remove();
  }
  static getRelevantAriaRole(e) {
    if (e === "inline")
      return "status";
  }
  addAnalyticsAttributes() {
    const e = this.type === "toast" ? "PU" : "ALRT";
    this.dataset.metricsLocation = e;
  }
  /**
   * Non-standard notifications default to a light mode. This will find the closest variant of light mode and add it to the class list.
   */
  addLightModeClasses() {
    if (this.variant !== "standard") {
      const e = this.closest(
        '[class*="beacon-on-light"]'
      );
      if (e) {
        const o = Array.from(e.classList).find(
          (i) => i.startsWith("beacon-on-light")
        );
        this.classList.add(o != null ? o : "beacon-on-light");
      } else
        this.classList.add("beacon-on-light");
    }
  }
  inertContentStatus() {
    if (this.type === "banner" && this.collapsed) return !0;
  }
  // aria-role is added to the most important text area since live regions read out text within as a single string
  // so semantics of an anchor link or button will not be noted
  render() {
    const e = {
      base: !0,
      dismissable: this.dismissable || this.type === "toast",
      expanded: !this.collapsed
    };
    return e[this.variant] = !0, e[this.type] = !0, a`
      <div class="${u(e)}">
        <div
          class="shell"
          role="${v(
      l.getRelevantAriaRole(this.type)
    )}">
          ${l.renderIcon(this.variant)}
          <div class="title" id="title" role="heading" aria-level="2">
            <slot></slot>
          </div>
          <div
            class="description"
            id="description"
            ?inert=${v(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="description"
                ${p({ container: ".description" })}></slot>
            </div>
          </div>
          <div
            class="action-zone"
            id="action-zone"
            ?inert=${v(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="action-zone"
                ${p({ container: ".action-zone" })}></slot>
            </div>
          </div>
          ${this.renderIconByType()}
        </div>
        ${this.renderBodySlot()}
      </div>
    `;
  }
}, l.tagName = m.beaconTagName, l.nestedComponents = m.nestedComponents, l);
d([
  g({ reflect: !0 })
], t.prototype, "type", 2);
d([
  g({ reflect: !0 })
], t.prototype, "variant", 2);
d([
  g({ type: Boolean })
], t.prototype, "dismissable", 2);
d([
  g({ type: Boolean, reflect: !0 })
], t.prototype, "collapsed", 2);
d([
  y
], t.prototype, "addAnalyticsAttributes", 1);
d([
  y
], t.prototype, "addLightModeClasses", 1);
let h = t;
const G = (e) => ($(e, h), z({
  tagName: e ? e + "-" + h.tagName : h.tagName,
  elementClass: h,
  react: B,
  events: {
    onBeaconEventDismiss: "beacon-event-dismiss",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  G as default,
  G as reactBeaconNotification
};
